import { IpaType } from "../../phonemes/ipa"

/** non-IPA with an obvious IPA replacement */
export const ipaSingle: Record<string, IpaType> = {
  "'": "ˈ",
  ",": "ˌ",
  "`": "ʼ",/*tʼ*/
  "|": "|",
  ";": "‖",
  "g": "ɡ",
}

/** shift-symbol with multiple IPA options you can cycle between */
export const ipaMulti: Record<string, IpaType[]> = {
  A: ["ɑ", "æ", "ɐ", "ɒ"],
  B: ["β", "ɓ", "ʙ"],
  C: ["ç", "ɕ"],
  D: ["ɖ", "ɗ", "ð", "ᶑ", "ᴅ"],
  E: ["ɛ", "ə", "ɘ", "ɜ"],
  F: ["ɸ", "ʄ"],
  G: ["ɢ", "ɠ", "ʛ"],
  H: ["ʰ", "ɦ", "ħ", "ʜ", "ɧ"],
  I: ["ɪ", "ɨ"],
  J: ["ʲ", "ɟ", "ʝ", "ɥ"],
  K: ["ǀ", "ǁ", "ǂ", "ʘ", "‼"],
  L: ["ɭ", "ȴ", "ɬ", "ɺ", "ɫ", "ʟ"],
  M: ["ɱ", "ʍ"],
  N: ["ŋ", "ɲ", "ɳ", "ȵ", "ɴ"],
  O: ["ɔ", "ø", "œ", "ɞ", "ɶ"],
  P: ["ɝ", "ɚ", "\u02DE"/*a˞ */],
  Q: ["ˀ", "ˤ", "ʕ", "ʢ", "ʡ"],
  R: ["ɾ", "ɻ", "ɹ", "ɽ", "ʁ", "ʀ"],
  S: ["ʃ", "ʂ", "ʆ"],
  T: ["ʈ", "ȶ", "θ"],
  U: ["ʊ", "ʉ", "ɵ"],
  V: ["ʌ", "ʋ", "ⱱ"],
  W: ["ʷ", "ɯ", "ɰ"],
  X: ["ɣ", "χ", "ˠ"],
  Y: ["ʎ", "ɤ", "ʏ"],
  Z: ["ʒ", "ʐ", "ʑ", "ɮ", "ʓ"],

  ":": ["ː", "ˑ", "\u0306"/*ĕ*/],       // length
  "%": ['˩', '˨', '˧', '˦', '˥'],       // tones
  "^": ["\u032F"/*e̯*/, "\u0329"/*n̩*/],  // syllabic
  "+": ["\u0361"/*t͡ʃ*/, "\u203F"/*o‿o*/], // ties
  "~": ["\u0303"/*ñ*/, "ⁿ"],            // nasal
  '"': ["\u0325"/*n̥*/, "\u032C"/*s̬*/, "\u0324"/*b̤*/, "\u0330"/*b̰*/],  // voicing
  "<": ["\u031E"/*e̞*/, "\u031D"/*e̝*/, "\u0318"/*e̘*/, "\u0319"/*e̙*/],  // tongue placement
  "$": ["\u0308"/*ë*/, "\u033D"/*e̽*/, "\u0339"/*e̹*/, "\u031C"/*e̜*/, "\u031F"/*e̟*/, "\u0320"/*e̠*/],
  "?": ["ʔ", "?"],
  "!": ["ǃ", "!"],
}
/** when showing the shortcuts, break after these indices for nice layout */
export const ipaMultiBreak = [
  5, 10, 15, 20, 25, 29, 33
];

/** IPA without a keyboard shortcut that can appear as buttons */
export const ipaMisc = [
  '\u032A', // dental
  '\u033A', // apical
  '\u033B', // laminal
  '\u033C', // linguolabial
  '\u031A', // not-audibly-released
  '˭', // tenuis
  'ˡ', // lateral-release
  '˦˨',
  '˥˩',
  '˨˦',
  '˩˥',
];
